<script>
  import axios from "axios";
  let name, email, phone, message, res;

  const submit = () => {
    if (!name || !email || !message) {
      alert("Please fill the mandatory fileds!");
      return;
    } else if (name || email || phone || message) {
      console.log(name, email, phone, message);
      axios
        .post("https://30253d.deta.dev/contact", {
          name,
          email,
          phone,
          message,
        })
        .then((data) => {
          res = data;
        })
        .catch((err) => {
          console.log(err);
        });
      return;
    }

    axios
      .post("https://30253d.deta.dev/contact", {
        name,
        email,
        phone: null,
        message,
      })
      .then((data) => {
        res = data;
      })
      .catch((err) => {
        console.log(err);
      });
  };
</script>

<main>
  <p class="font-light text-3xl text-center py-2">
    Get <span class="font-semibold">In Touch</span>
  </p>
  <div
    class="container flex flex-wrap md:justify-center items-start md:space-x-20 md:space-y-0 space-y-10 py-4"
  >
    <div class="space-y-8 md:w-2/5 w-full md:px-0 px-6">
      <h1 class="text-xl font-light">
        Write To <span class="font-semibold">Me! </span>
      </h1>
      <div class="">
        <div class="flex flex-col justify-center items-start space-y-4 py-2">
          <input
            bind:value={name}
            class="input-custom "
            type="text"
            name=""
            id=""
            placeholder="Your Name"
          />
          <input
            bind:value={email}
            class="input-custom "
            type="email"
            name=""
            id=""
            placeholder="Your Email"
          />
          <input
            bind:value={phone}
            class="input-custom "
            type="tel"
            name=""
            id=""
            placeholder="Your Phone"
          />
          <textarea
            bind:value={message}
            class="input-custom h-40"
            name=""
            id=""
            cols="20"
            rows="5"
            placeholder="Write a Message"
          />

          <button class="btn btn-info" on:click={submit}>Send message</button>
        </div>
      </div>
      {#if res}
        <div>
          <h1 class="text-green-500 text-lg">Data Saved!</h1>
        </div>
      {/if}
    </div>
    <div class="space-y-8 md:px-0 px-6">
      <h1 class="font-light text-xl">
        Contact <span class="font-semibold">Me </span>
      </h1>
      <div class="space-y-4">
        <div class="space-y-2">
          <p class="uppercase text-sm text-blue-500">Email</p>
          <p class=" text-md">azharuddinmohammed998@gmail.com</p>
        </div>
        <div class="space-y-2">
          <p class="uppercase text-sm text-blue-500">LinkedIn</p>
          <p class=" text-sm">
            <a href="https://www.linkedin.com/in/azar-m-/" target="_blank">
              <img
                src="/assets/images/social/linkedin.svg"
                class="w-24 bg-[#fafafa] rounded-md p-2"
                alt=""
              />
            </a>
          </p>
        </div>
        <div class="space-y-2">
          <p class="uppercase text-sm text-blue-500">Instagram</p>
          <p class=" text-sm">
            <a href="https://www.instagram.com/mr.cool.___/" target="_blank">
              <img
                src="/assets/images/social/instagram.svg"
                class="w-24 bg-[#fafafa] rounded-md"
                alt=""
              />
            </a>
          </p>
        </div>
        <div class="space-y-2">
          <p class="uppercase text-sm text-blue-500">Github</p>
          <p class=" text-sm">
            <a href="https://github.com/MrAzharuddin" target="_blank" >
              <img
                src="/assets/images/social/github.png"
                class="w-24 bg-[#fafafa] rounded-md"
                alt=""
              />
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</main>
